var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useMemo } from "react";
import { parseCurrencyToInt, formatCurrency, clampCashOutValueIfNeeded, parseUpstreamCashOutAmounts, getCashOutBorrowingLimit } from "../../services/validation";
import Slider from "./Slider";
import { getEstPriceForState, getLtvRatioFromFieldConfig, getValidationRuleValue, isCashOutField } from "../../services/dfUtils";
import { formDataInStorage, getValueBySuffix } from "../../services/helperLib";
export default function CurrencyInput(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h;
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur;
    var fieldConfig = field.config, fieldValue = field.fieldValue;
    var _j = useState(fieldValue || ""), rawValue = _j[0], setRawValue = _j[1];
    var typingTimeout = useRef(null);
    var min = (_b = getValidationRuleValue(fieldConfig, "min")) !== null && _b !== void 0 ? _b : Number((_d = (_c = fieldConfig.minValue) !== null && _c !== void 0 ? _c : fieldConfig.sliderMinValue) !== null && _d !== void 0 ? _d : 0);
    var max = (_e = getValidationRuleValue(fieldConfig, "max")) !== null && _e !== void 0 ? _e : Number((_g = (_f = fieldConfig.maxValue) !== null && _f !== void 0 ? _f : fieldConfig.sliderMaxValue) !== null && _g !== void 0 ? _g : 10000000);
    var step = Number((_h = fieldConfig.sliderStepValue) !== null && _h !== void 0 ? _h : 2500);
    var includeSlider = !!fieldConfig.includeSlider;
    var isCashOut = isCashOutField(fieldConfig.fieldId);
    var upstreamAmounts = isCashOut ? parseUpstreamCashOutAmounts(formDataInStorage()) : null;
    var borrowingLimit = upstreamAmounts
        ? getCashOutBorrowingLimit(upstreamAmounts.homeValue, upstreamAmounts.loanAmt, getLtvRatioFromFieldConfig(fieldConfig))
        : null;
    // Reset to max borrowing limit when home value or loan balance changes (not while user types).
    useEffect(function () {
        if (!isCashOut || !upstreamAmounts || borrowingLimit === null)
            return;
        var savedValue = fieldValue || "";
        if (!savedValue)
            return;
        var _a = clampCashOutValueIfNeeded(savedValue, upstreamAmounts.homeValue, upstreamAmounts.loanAmt, getLtvRatioFromFieldConfig(fieldConfig)), clampedValue = _a.clampedValue, didClamp = _a.didClamp;
        if (!didClamp)
            return;
        setRawValue(clampedValue);
        onChange(clampedValue, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [upstreamAmounts === null || upstreamAmounts === void 0 ? void 0 : upstreamAmounts.homeValue, upstreamAmounts === null || upstreamAmounts === void 0 ? void 0 : upstreamAmounts.loanAmt, borrowingLimit, isCashOut]);
    useEffect(function () {
        if (fieldValue != null && fieldValue !== rawValue) {
            setRawValue(fieldValue);
        }
    }, [fieldValue]);
    var numericValue = parseCurrencyToInt(rawValue);
    var sessionData = useMemo(function () { return formDataInStorage(); }, []);
    // Auto-populate loan amount based on state field
    useEffect(function () {
        var fetchStateAverage = function () { return __awaiter(_this, void 0, void 0, function () {
            var selectedState, avgValue, formatted, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((fieldConfig.fieldId === "loanAmt_P" || fieldConfig.fieldId === "homeValueAmt") && fieldValue == null)) return [3 /*break*/, 5];
                        selectedState = getValueBySuffix(sessionData, "_state");
                        if (!selectedState) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getEstPriceForState(selectedState)];
                    case 2:
                        avgValue = _a.sent();
                        if (avgValue) {
                            formatted = formatCurrency(avgValue);
                            setRawValue(formatted);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error fetching state average:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        handleBlur();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchStateAverage();
    }, []);
    useEffect(function () {
        if (rawValue) {
            var timeoutId_1 = setTimeout(function () {
                onChange(rawValue);
            }, 100);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [rawValue]);
    var handleChange = function (e) {
        if (typingTimeout.current)
            clearTimeout(typingTimeout.current);
        var numeric = e.target.value.replace(/[^\d]/g, "");
        if (!numeric) {
            setRawValue("");
            onChange("");
            return;
        }
        var num = Math.min(Number(numeric), max);
        var formatted = formatCurrency(num);
        setRawValue(formatted);
        onChange(formatted);
        typingTimeout.current = setTimeout(function () { return onChange(formatted); }, 150);
    };
    var handleBlur = function () {
        var num = parseCurrencyToInt(rawValue);
        var clamped = Math.min(Math.max(num, min), max);
        var formatted = formatCurrency(clamped);
        setRawValue(formatted);
        onChange(formatted, true);
        onBlur();
    };
    var handleSliderChange = function (e) {
        var num = Math.min(Math.max(Number(e.target.value), min), max);
        var formatted = formatCurrency(num);
        setRawValue(formatted);
        onChange(formatted);
    };
    return (_jsxs("div", { className: "currency", children: [_jsx("label", { htmlFor: fieldConfig.fieldId, className: "visually-hidden", children: fieldConfig.label || "Currency input" }), _jsx("input", { id: fieldConfig.fieldId, type: "text", className: "currency-input", placeholder: "$0", inputMode: "numeric", autoComplete: "off", min: min, max: max, value: rawValue, onChange: handleChange, onBlur: handleBlur }), _jsx(Slider, { value: numericValue > max ? max : numericValue, step: step, min: min, max: max, onChange: handleSliderChange, fieldId: fieldConfig.fieldId, label: fieldConfig.label || "Currency input" })] }));
}
